export default __webpack_public_path__ + "aaa0a34c790b3eaf04b518aa2cc1d3b7.svg";